/** 회원가입·랜딩 약관/개인정보 HTML 캐시 — updated_at 버전 비교 */

import type { SignupLegalHtml } from '../services/signupLegalService';

const STORAGE_KEY = 'cp.signupLegalDocuments.v1';

export type SignupLegalCachePayload = SignupLegalHtml & {
  terms_updated_at: string;
  privacy_updated_at: string;
};

export function loadSignupLegalDocumentsCache(): SignupLegalCachePayload | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SignupLegalCachePayload>;
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      terms_html: typeof parsed.terms_html === 'string' ? parsed.terms_html : '',
      privacy_html: typeof parsed.privacy_html === 'string' ? parsed.privacy_html : '',
      terms_updated_at: typeof parsed.terms_updated_at === 'string' ? parsed.terms_updated_at : '',
      privacy_updated_at: typeof parsed.privacy_updated_at === 'string' ? parsed.privacy_updated_at : '',
    };
  } catch {
    return null;
  }
}

export function saveSignupLegalDocumentsCache(payload: SignupLegalCachePayload): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* quota */
  }
}

export function signupLegalCacheMatchesMeta(
  cache: SignupLegalCachePayload | null,
  meta: { terms_updated_at: string; privacy_updated_at: string }
): boolean {
  if (!cache) return false;
  return (
    cache.terms_updated_at === meta.terms_updated_at &&
    cache.privacy_updated_at === meta.privacy_updated_at
  );
}
